import service from '../utils/request'
// 查询黑名单
export const querybarriergatelist = params => {return service.post(`/api/base_barriergate/query`, params)};
// 创建
export const createbarriergate = params => {return service.post(`/api/base_barriergate/create`, params)};
// 修改
export const editbarriergate = params => {return service.put(`/api/base_barriergate/edit`, params)};
// 删除
export const deletebarriergate = params => {return service.delete(`/api/base_barriergate/delete`, {params})};
export const dzcmd = params => {return service.post(`/api/base_barriergate/dzcmd`, params)};
